export default {
  mainCompanyInfo(state) {
    return state.mainCompanyInfo;
  }
};
